var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layout === 'subgroup')?_c('SubgroupDetail'):_vm._e(),(_vm.layout === 'disease')?_c('Disease'):(_vm.layout === 404)?_c('div',[_c('Choch',{staticClass:"inPage"})],1):(_vm.layout === false)?_c('div',[_c('Error',{staticClass:"inPage"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }